export function trimTo2Decimals(num: number) {
  return Math.floor(num * 100) / 100;
}

export function trimTo1Decimal(num: number) {
  return (Math.floor(num * 100) / 100).toFixed(1);
}

export function formatNumber(number: number | string) {
  return new Intl.NumberFormat('en-US').format(Number(number));
}